import { render, staticRenderFns } from "./VmodalSupportCollapse.vue?vue&type=template&id=d167d214"
import script from "./VmodalSupportCollapse.vue?vue&type=script&lang=js"
export * from "./VmodalSupportCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports